var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4545 3.68985L12.225 4.46031L7.85356 8.83176L3.48212 4.46031L4.25805 3.68438L7.30713 6.73893V0.0888672H8.39999V6.73893L11.4545 3.68985ZM0 7.73894V10.8372C0 11.8037 0.783502 12.5872 1.75 12.5872H13.9572C14.9237 12.5872 15.7072 11.8037 15.7072 10.8372V7.73894H14.2072V10.8372C14.2072 10.9752 14.0953 11.0872 13.9572 11.0872H1.75C1.61193 11.0872 1.5 10.9752 1.5 10.8372V7.73894H0Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconWhite);
export default __webpack_public_path__ + "static/media/download-icon-white.ddb4ed74fb6fa25244477cb6c2281b78.svg";
export { ForwardRef as ReactComponent };